<template>
    <div class="list-select">
        <ilabel :m="m" :label="label" :required="required" />
        <select v-model="selected" @change="onSelect">
            <option :value="undefined">{{placeholder}}</option>
            <option :selected="option.value == value" v-for="option in opts" :value="option.value"> {{ option.label }} </option>
        </select>
    </div>
</template>
<script>
export default {
    name: "list-select",
    mounted() {
        if (this.options.length) {
            if (typeof this.options[0] === 'object') {
                this.opts = this.options;
            } else {
                this.opts = this.options.map(o => ({ label: o, value: o }));
            }
        }
        this.selected = this.value;
    },
    watch: {
        value() {
            this.selected = this.value;
        }
    },
    props: {
        "options": { type: Array, default () { return [{ label: 'one', value: 1 }, { label: 'two', value: 2 }, { label: 'three', value: 3 }] } },
        "value": { type: [String, Number, Boolean] },
        "m": { type: String },
        "label": { type: String },
        "required": { type: Boolean, default: false },
        "placeholder": { type: String, default: 'Select please' }
    },
    data() {
        return {
            opts: [],
            selected: ""
        }
    },
    methods: {
        onSelect(e, v) {
            this.$emit('input', this.selected);
        }
    }
}
</script>
<style scoped>
.list-select {
    text-align: left;
}

.list-select select {
    border: 1px solid lightgrey;
    padding: 4px 8px;
    font-size: 14px;
    outline: none;
    width: 100%;
    border-radius: 0px;
    background: white;
    vertical-align: top;
    margin-bottom: 12px;
    -webkit-appearance: none;
    border-radius: 4px;
}

.list-select:hover select {
    background: whitesmoke;
    cursor: pointer;
}

.list-select:active select {
    background: lightgrey;
}

.red {
    color: red
}

label {
    color: #2b2b2b;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 6px;
    display: block;
    text-align: left;
}
</style>